import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { SelskapsHeader } from "@/components/header/SelskapsHeader";
import { env } from "@/env";
import { InnstillingerManglerAdvarsler } from "@/features/innstillinger/InnstillingerManglerAdvarsler";
import { ActiveSelskapStorageKey } from "@/features/selskap/SelskapContext";
import { getPersistantState } from "@/hooks/usePersistantState";
export const Route = createFileRoute("/_app/_subheader")({
  component: PageWithSubHeaderComponent,
  beforeLoad() {
    const selectedSelskap = getPersistantState(
      ActiveSelskapStorageKey,
      localStorage,
    );
    if (!selectedSelskap) {
      throw redirect({ to: "/selskap" });
    }
  },
});

function PageWithSubHeaderComponent() {
  return (
    <div>
      <SelskapsHeader />
      {env.featureInnstillingerEnabled && <InnstillingerManglerAdvarsler />}
      <Outlet />
    </div>
  );
}
